const headerMenuDropdown = {
  menuMobile: () => {
    $(".themeHeader__topbar--click").on("click", function (e) {
      $(".themeHeader__navigation").slideToggle();
      $('.themeHeader__topbar--appointment.mobile').toggleClass('close-x')
    })

    $(".themeHeader__topbar--appointment.mobile a").on("click", function (e) {
      e.preventDefault()
      $(".themeHeader__navigation").slideToggle();
      $('.themeHeader__topbar--appointment.mobile').toggleClass('close-x')
    });
  },
  initializeDropdown: () => {
    $(".themeHeader__menu .menu-item-has-children > a").on(
      "click",
      function (e) {
        e.preventDefault();
        const element = $(this).parent(); // O item do menu atual

        if (!element.hasClass("isActive")) {
          // Fecha outros submenus abertos no mesmo nível
          element
            .siblings(".menu-item-has-children")
            .removeClass("isActive")
            .find(".sub-menu")
            .slideUp();

          // Abre o submenu associado ao item clicado
          element.addClass("isActive");
          element.children(".sub-menu").slideDown();
        } else {
          // Fecha o submenu associado ao item clicado
          element.removeClass("isActive");
          element.children(".sub-menu").slideUp();
        }
      }
    );
  },
  init: () => {
    headerMenuDropdown.menuMobile();
    headerMenuDropdown.initializeDropdown();
  },
};

export default headerMenuDropdown;
